// extracted by mini-css-extract-plugin
export var columnHeader = "footer-section-module--column-header--dTiTP";
export var columnInfo = "footer-section-module--column-info--Ce7ug";
export var columnLink = "footer-section-module--column-link--ZKa7o";
export var logoWrapper = "footer-section-module--logo-wrapper--rZAVS";
export var neonSeparatorLeft = "footer-section-module--neon-separator-left--driaD";
export var neonSeparatorRight = "footer-section-module--neon-separator-right--ROUN3";
export var neonSeparatorWrapper = "footer-section-module--neon-separator-wrapper--WYber";
export var socialIconsRow = "footer-section-module--social-icons-row--mS4DU";
export var wrapper = "footer-section-module--wrapper--hpGpp";